import { useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { FileContext } from '@app/providers';
import { openImportTemplateFile } from '@app/utils';

import type { InputRef } from 'antd';
import type { ChangeEvent } from 'react';

interface UseExcelImportParams {
  templateEndpoint: string;
  importPath: string;
}

export const useExcelImport = ({
  templateEndpoint,
  importPath,
}: UseExcelImportParams) => {
  const navigate = useNavigate();

  const { setFile, setExtension } = useContext(FileContext);

  const importInputRef = useRef<InputRef>(null);

  const handleImportExcelClick = () => {
    importInputRef.current?.input?.click();
  };

  const handleExportExcelTemplateClick = async () => {
    openImportTemplateFile(templateEndpoint);
  };

  const updateFileByExcel = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    const filename = file?.name;
    const extension = filename?.split('.').pop() || '';

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        if (typeof reader.result === 'string') {
          const base64String = reader.result
            ?.replace('data:', '')
            .replace(/^.+,/, '');
          setFile(base64String);
          setExtension(extension);
          navigate(importPath, {
            state: {
              file: base64String,
              extension,
            },
          });
        }
      };
    }
  };

  return {
    importInputRef,
    handleImportExcelClick,
    handleExportExcelTemplateClick,
    updateFileByExcel,
  };
};
